import React from 'react';

const Email = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="34" fill="none" viewBox="0 0 42 34">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M4.378 0C2.083 0 .223 1.903.223 4.25v25.5c0 2.347 1.86 4.25 4.155 4.25h33.245c2.295 0 4.155-1.903 4.155-4.25V4.25c0-2.347-1.86-4.25-4.155-4.25H4.378zm30.903 4.25H6.721l14.28 8.79 14.28-8.79zM4.378 7.713V29.75h33.245V7.714l-16.621 10.23L4.378 7.713z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default Email;
